import React, { Component } from 'react'
import {
  Modal,
  ModalBackground,
  Delete,
  ModalCard,
  ModalCardBody,
  ModalCardFooter,
  ModalCardHeader,
  ModalCardTitle,
  Button,
  Field, Control, Input, Label, Select as BSelect, Help
} from 'bloomer'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import styled from 'styled-components'

const Select = styled(BSelect)`
  width: 100%;
`

const ADD_MODULE = gql`
  mutation ($identifier: String!, $roomId: UUID!, $name: String!) {
    addModule(identifier: $identifier, roomId: $roomId, name: $name) {
      module {
        id
      }
    }
  }
`


const GET_MODULE_AVAILABLE = gql`
  mutation ($identifier: String!) {
    getModuleAvailable(identifier: $identifier) {
      module {
        id,
        moduleModel {
          name
        }
      }
    }
  }
`

const initialState = {
  identifier: {
    error: null,
    value: ''
  },
  name: {
    error: null,
    value: ''
  },
  room: {
    error: null,
    value: ''
  },
}

export default class AddModuleModal extends Component {
  state = {
    ...initialState
  }

  validateNotEmpty = (key, message) => {
    const { value } = this.state[key]

    if (value.trim() === '') {
      this.setState(() => ({
        [key]: {
          ...this.state[key],
          error: message
        }
      }))
      return false
    }

    this.setState(() => ({
      [key]: {
        ...this.state[key],
        error: ''
      }
    }))
    return true
  }

  validateIdentifier = async (getModuleAvailableMutation) => {
    const { identifier, name } = this.state

    if (identifier.value === '') {
      this.setState(() => ({
        identifier: {
          ...identifier,
          error: 'Informe o identificador do novo módulo'
        }
      }))
      return
    } else {
      this.setState(() => ({
        identifier: {
          ...identifier,
          error: ''
        }
      }))
    }

    try {
      const result = await getModuleAvailableMutation()

      if (name.value.trim() === '') {
        this.setState(() => ({
          name: {
            ...name,
            value: result.data.getModuleAvailable.module.moduleModel.name
          }
        }))
      }
    } catch(e) {
      console.error(e)
      this.setState(() => ({
        identifier: {
          ...identifier,
          error: 'Não foi possível validar o identificador informado'
        }
      }))
    }
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({
      [key]: {
        ...this.state[key],
        value
      }
    }))
  }

  handleClose = (evt) => {
    evt.preventDefault()

    this.setState(() => ({
      ...initialState
    }))

    this.props.handleClose(evt)
  }

  handleSubmit = async (addModuleMutation, evt) => {
    evt.preventDefault()

    const fields = [
      ['name', 'Informe um nome para o novo módulo'],
      ['identifier', 'Informe o identificador do novo módulo'],
      ['room', 'Escolha o cômodo onde está o novo módulo']
    ]

    const cleanFields = fields.filter((args) => {
      return this.validateNotEmpty(...args)
    })

    if (cleanFields.length !== fields.length) {
      return
    }

    try {
      await addModuleMutation()

      this.setState(() => ({
        ...initialState
      }))

      this.props.handleClose(evt)
      this.props.refetch()
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const { isActive, rooms } = this.props
    const { identifier, name, room } = this.state

    return (
      <Modal isActive={isActive}>
        <ModalBackground onClick={this.handleClose}/>
        <Mutation mutation={GET_MODULE_AVAILABLE} variables={{identifier: identifier.value}}>
          {(getModuleAvailable) => (
            <Mutation mutation={ADD_MODULE} variables={{identifier: identifier.value, name: name.value, roomId: room.value}}>
              {(addModule, {loading}) => (
                <ModalCard tag="form" onSubmit={this.handleSubmit.bind(this, addModule)}>
                  <ModalCardHeader>
                    <ModalCardTitle>Adicionar módulo</ModalCardTitle>
                    <Delete onClick={this.handleClose} />
                  </ModalCardHeader>
                  <ModalCardBody>
                    <Field>
                      <Control>
                        <Label>Identificador</Label>
                        <Input
                          type="text"
                          placeholder="ABC123"
                          isColor={identifier.error ? 'danger' : null}
                          onChange={this.handleChange('identifier').bind(this)}
                          onBlur={this.validateIdentifier.bind(this, getModuleAvailable)}
                          autoFocus
                          value={identifier.value} />
                        {identifier.error && <Help isColor="danger">{identifier.error}</Help>}
                      </Control>
                    </Field>
                    <Field>
                      <Control>
                        <Label>Nome</Label>
                        <Input type="text" placeholder="Luz" isColor={name.error ? 'danger' : null} onChange={this.handleChange('name').bind(this)} value={name.value} />
                        {name.error && <Help isColor="danger">{name.error}</Help>}
                      </Control>
                    </Field>
                    <Field>
                      <Control>
                        <Label>Cômodo</Label>
                        <Select isColor={room.error ? 'danger' : null} onChange={this.handleChange('room').bind(this)} value={room.value} style={{width: "100%"}}>
                          <option value="" disabled>Escolha</option>
                          {rooms.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                        </Select>
                        {room.error && <Help isColor="danger">{room.error}</Help>}
                      </Control>
                    </Field>
                  </ModalCardBody>
                  <ModalCardFooter>
                    <Button type="submit" isLoading={loading} isColor="success">Adicionar</Button>
                    <Button onClick={this.handleClose}>Cancelar</Button>
                  </ModalCardFooter>
                </ModalCard>
              )}
            </Mutation>
          )}
        </Mutation>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/modals/AddModuleModal.js